import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    ScrollView,
} from "react-native";

import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Text from "../components/Text";
import * as Constants from "../utils/Constants";
import * as Animatable from "react-native-animatable";
import * as ServerOperations from "../utils/ServerOperations";
import CheckOut from "../scenes/CheckOut";
import MyOrders from "../scenes/MyOrders";
import StatementOfAccount from "../scenes/StatementOfAccount";
import InvoicesReturns from "../scenes/InvoicesReturns";
import Profile from "../scenes/Profile";
import Shop from "../scenes/Shop";
import CheckoutMini from "../scenes/CheckOutMini";
import OrderNow from "../scenes/OrderNow";
import ProductDetails from "../scenes/ProductDetails";
import Notifications from "../scenes/Notifications";
let height = Dimensions.get("window").height;
let width = Dimensions.get("window").width;
let styles = {};
let isMobile = false;
let scale = 1;
// const drawerIconImgLight = require("../../assets/logo.png");
// const SOAimg = require("../images/ClientHomePage/SOA.png");
// const IRimg = require("../images/ClientHomePage/IR.png");
// const OrderImg = require("../images/ClientHomePage/Order.png");
const SOAimgDesktop = require("../images/ClientHomePage/SOA.png");
const InvRetDesktop = require("../images/ClientHomePage/IR.png");
const orderDesktop = require("../images/Commons/myorders.png");
// const profileDesktop = require("../images/ClientHomePage/profileDesktop.png");
// const imgLogoutDesktop = require("../images/ClientHomePage/logoutIcon.png");
// const RoundBlueButton = require("../images/ClientHomePage/RoundButton.png");
const imgProfile = require("../images/Header/Profile.png");
// const imgJdsLogo = require("../images/Header/JdsLogo.png");
// const imgOrderPlaced = require("../images/MyOrders/OrderPlaced.png");
// const imgOrderShipped = require("../images/MyOrders/OrderShipped.png");
// const imgOrderDelivered = require("../images/MyOrders/OrderDelivered.png");
// const CloseIcon = require("../images/InvoiceDetails/closeIcon.png");
// const imgOrderAccepted = require("../images/MyOrders/OrderAccepted.png");
// const imgOrderOutOfStock = require("../images/MyOrders/OrderOutOfStock.png");
// const imgOrderReturned = require("../images/MyOrders/OrderReturned.png");
// const imgArrowDown = require("../images/MyOrders/OrderArrowDown.png");
const imgJdsLogoDesktop = require("../images/ClientHomePage/jdsLogo.png");
const imgHome = require("../images/Shop/orderNow.png");

class DesktopSidebar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showDueBalance: true,
            userImage: '',
            userName: '',
            menuItems: [],
            soaBalance: '',
            width: Dimensions.get("window").width,
            totalBalance: 0,
            currentTab: '',
            showInvoice: '',
            showReturn: '',
            showCart: false,
        };
    }


    render() {
        this.title = 'Desktop Sidebar';
        Commons.resizeHandle(window, this, () => {
            width = this.width;
            height = this.height;
            setTimeout(() => {
                this.setState({ width, height });
            }, 100);
        });
        width = Dimensions.get("window").width;
        height = Dimensions.get("window").height;
        isMobile = Commons.isMobile();

        let currentTab = this.state.currentTab;
        if (!currentTab) currentTab = this.props.selectedTab;

        if (isMobile) {
            switch (currentTab) {
                case STRINGS.shop_home:
                    window.location = './shop';
                    break;
                case STRINGS.Orders:
                    window.location = './myorders';
                    break;
                case STRINGS.Statement_of_Account_Desktop:
                    window.location = './statementofaccount';
                    break;
                case STRINGS.Desktop_Invoices:
                    window.location = './invoicesreturns?type=invoice';
                    break;
                case STRINGS.Desktop_Returns:
                    window.location = './invoicesreturns?type=return';
                    break;
                case STRINGS.profile_Desktop:
                    window.location = './profile';
                    break;
                case STRINGS.app_Order_Now:
                    window.location = './ordernow';
                    break;
                case STRINGS.checkout:
                    window.location = './checkout';
                    break;
                default:
                    window.location.reload();
            }
            return null;
        }
        styles = this.styles();
        scale = height / 900;
        const menuItems = [
            {
                style: { marginTop: -10 },
            },
            {
                location: 'shop',
                image: imgHome,
                text: STRINGS.app_Order_Now,
            },
            {
                location: 'myorders',
                image: orderDesktop,
                text: STRINGS.Orders,
            },
            {
                location: 'StatementOfAccount',
                image: SOAimgDesktop,
                text: STRINGS.Statement_of_Account_Desktop,
            },
            {
                location: 'InvoicesReturns?type=invoice',
                image: InvRetDesktop,
                text: STRINGS.Desktop_Invoices,
            },
            {
                location: 'InvoicesReturns?type=return',
                image: InvRetDesktop,
                text: STRINGS.Desktop_Returns,
            },
            {
                image: imgProfile,
                text: STRINGS.profile_Desktop,
            }
        ];

        const size = menuItems.length;
        const menuScale = Commons.getMenuScale();
        let fontSize = (AppStyles.H3FontSize + 2) * (scale < 1 ? scale : 1);
        if (fontSize > 14) fontSize = 14;
        return (
            [
                Commons.loadFonts(this, false, false, 1),
                this.state.showNotifications && this.renderNotifications(),
                <View style={{ flex: 1, flexDirection: 'row', gap: 20, backgroundColor: '#fff', height: '100%', width: '100%' }}>
                    <View style={{ gap: 20, width: 320 * menuScale, height: height, position: 'relative' }}>
                        <TouchableOpacity onPress={() => {
                            if (this.state.currentTab == STRINGS.shop_home) {
                                window.location.reload();
                            }
                            this.setState({ currentTab: STRINGS.shop_home });
                        }}>
                            <Image source={imgJdsLogoDesktop} style={{ width: 168, height: 52.017 * scale, minHeight: 38, marginLeft: 30 * scale, marginTop: 30 }} resizeMode="contain" />
                        </TouchableOpacity>
                        {/* <View style={[this.state.style, { alignItems: 'flex-start', marginTop: 0, gap: 10, backgroundColor: '#fff', }]}> */}
                        <View style={{ alignItems: 'flex-start', marginTop: 0, gap: 10, backgroundColor: '#fff', }}>
                            <View style={{ marginTop: 0, marginLeft: 25 }}>
                                {menuItems.slice(1).map((item, index) => (
                                    <View style={[{}, item.style, { backgroundColor: '#fff' }]}>
                                        <View key={index} style={[{
                                            width: 320 * menuScale, height: 60 * scale, alignItems: 'center',
                                            justifyContent: 'flex-start', gap: 10, flexDirection: 'row',
                                        },
                                        currentTab !== item.text ? { backgroundColor: '#FFF' } : {},
                                        ]}>
                                            <TouchableOpacity
                                                activeOpacity={1}
                                                // disabled={this.state.disabled || this.state.style?.opacity < 0.6}
                                                onPress={() => {
                                                    if (item.text === STRINGS.logout_Desktop) {
                                                        Commons.saveToAS(Constants.TOKEN, '');
                                                        window.location = './login';
                                                    } if (item.text == this.state.currentTab && this.currentComponent) {
                                                        this.currentComponent.setState({
                                                            showInvoiceDetails: false,
                                                            showReturnDetails: false,
                                                            showInvDetails: false,
                                                            showRetDetails: false,
                                                            showProductDetails: false,
                                                            showOrderDetails: false,
                                                            showOrderNow: false,
                                                            showInvoiceDesktop: item.text === STRINGS.Desktop_Invoices,
                                                            showReturnDesktop: item.text === STRINGS.Desktop_Returns,
                                                        });
                                                    } else {
                                                        this.setState({ currentTab: item.text });

                                                    }
                                                }}
                                                style={[{
                                                    backgroundColor: '#fff',
                                                    width: 348 * menuScale,
                                                    height: 70 * scale,
                                                    alignItems: 'center',
                                                    flexDirection: 'row',
                                                    gap: 19,
                                                    paddingHorizontal: 21,
                                                },
                                                currentTab === item.text ? { opacity: 1 } : { opacity: 0.65 },
                                                index < size - 2 && currentTab === menuItems[index + 2].text ? { borderBottomEndRadius: 62 } : {},
                                                index > 0 && currentTab === menuItems[index].text ? { borderTopEndRadius: 62 } : {},
                                                currentTab === item.text ? { borderTopLeftRadius: 62, borderBottomLeftRadius: 62 } : {}
                                                ]}
                                            >
                                                <Image source={item.image} style={{ width: 24 * scale, height: 24 * scale }} tintColor={'#9197B3'} />
                                                <Text style={[AppStyles.H3Styles, { fontSize }]}>{item.text}</Text>
                                            </TouchableOpacity>
                                        </View>
                                    </View>
                                ))}
                            </View>
                        </View>
                        {/* Checkout at the bottom */}
                        {this.state.showCart && (
                            <View style={{
                                position: 'absolute',
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'transparent',
                            }}>
                                {/* <Text style={
                                    [
                                        AppStyles.desktopCartName,
                                        {
                                            marginHorizontal: 50,
                                            marginBottom: 15,
                                            fontSize: 20 * scale
                                        }
                                    ]}>{STRINGS.desktop_cart}</Text> */}
                                <CheckoutMini self={this} showProductDetails={(item) => {
                                    this.setState({ prevTab: this.state.currentTab, currentTab: STRINGS.products, productID: item.ID });
                                }} />
                            </View>
                        )}
                    </View>
                    <View style={{ flex: 1, backgroundColor: AppStyles.desktopBackgroundColor }}>
                        <ScrollView style={[{
                            height: '100%', backgroundColor: AppStyles.desktopBackgroundColor,
                            width: width - (355 * menuScale),
                        }, currentTab === STRINGS.app_Order_Now && { paddingLeft: 16 }]}>
                            {currentTab === STRINGS.Orders && <MyOrders self={this} />}
                            {currentTab === STRINGS.Statement_of_Account_Desktop && <StatementOfAccount self={this} />}
                            {currentTab === STRINGS.Desktop_Invoices && <InvoicesReturns type={currentTab} self={this} />}
                            {currentTab === STRINGS.Desktop_Returns && <InvoicesReturns type={currentTab} self={this} />}
                            {currentTab === STRINGS.profile_Desktop && <Profile self={this} />}
                            {currentTab === STRINGS.shop_home && <Shop self={this} />}
                            {currentTab === STRINGS.app_Order_Now && <OrderNow self={this} />}
                            {currentTab === STRINGS.checkout && <CheckOut self={this} products={this.shop ? this.shop.state.products : []} />}
                            {currentTab === STRINGS.products &&
                                <ProductDetails self={this} productID={this.state.productID}
                                    showProductsDetails={
                                        async () => {
                                            this.setState({ currentTab: this.state.prevTab || STRINGS.shop_home });
                                        }}
                                />}
                        </ScrollView>
                    </View>
                </View >
            ]
        );
    }

    renderNotifications() {
        return (
            <View style={{
                position: 'absolute', height,
                flex: 1,
                zIndex: 100,
                left: 0,
                top: 0,
                flexDirection: 'row',
            }}>
                <TouchableOpacity
                    onPress={() => {
                        this.setState({ showNotifications: false });
                    }}
                    style={{ width: width - 387, background: '#fafeff', opacity: 0.3 }}></TouchableOpacity>
                <Animatable.View
                    ref={ref => this.notificationsView = ref}
                    animation={this.state.showNotifications ? "slideInRight" : "slideOutRight"}
                    duration={300}
                    style={{
                        background: '#fff',
                        width: 387,
                        height: '100%',
                        zIndex: 109,
                        opacity: 1
                    }}>
                    <TouchableOpacity style={{ flex: 1, cursor: 'default' }}>
                        <Notifications self={this} width={387} />
                    </TouchableOpacity>
                </Animatable.View>
            </View>
        );
    }

    async componentDidMount() {
        const accountInfo = await ServerOperations.getUserInfo();
        if (accountInfo) {
            this.setState({ accountInfo, userImage: accountInfo.IMGURL ? accountInfo.IMGURL : imgProfile, userName: accountInfo.NAME, totalBalance: accountInfo.BALANCE });
        }
        let resp = await ServerOperations.getOrders('', '', '');
        if (resp.ORDS) {
            this.setState({ orders: resp.ORDS });
        } else {
            const token = await Commons.getFromAS(Constants.TOKEN);
            if (!token) {
                window.location = './login';
            }
        }
        const parsedItems = await Commons.getBasketItems();
        try {
            if (parsedItems && parsedItems.length > 0) {
                this.setState({ showCart: true });
            }
        } catch (e) {
            console.log('Failed to parse ITEMS_IN_BASKET:', e);
            console.log(parsedItems);
        }
        this.miniCheckoutTimer = setInterval(() => {
            Commons.getBasketItems().then((items) => {
                if (items && items.length > 0) {
                    if (!this.state.showCart)
                        this.setState({ showCart: true });
                } else {
                    if (this.state.showCart)
                        this.setState({ showCart: false });
                }
            });
        }, 2000);
    }

    componentWillUnmount() {
        if (this.miniCheckoutTimer) clearInterval(this.miniCheckoutTimer);
    }

    styles = () => ({
        container: {
            flex: 1,
            alignItems: "center",
            backgroundColor: WHITE
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            height: 590,
        }
    });

}


export default DesktopSidebar;